import { render, staticRenderFns } from "./ClientBalance.vue?vue&type=template&id=caa27b02&scoped=true"
import script from "./ClientBalance.vue?vue&type=script&lang=js"
export * from "./ClientBalance.vue?vue&type=script&lang=js"
import style0 from "./ClientBalance.vue?vue&type=style&index=0&id=caa27b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa27b02",
  null
  
)

export default component.exports